import { Component, OnInit, EventEmitter, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import {GenericModalService} from "../../lib/services/generic-modal/generic-modal.service";
import * as pubsub from "pubsub-js"

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent implements OnInit {
  @Output() modalOpened: EventEmitter<any> = new EventEmitter();
  @Output() modalClosed: EventEmitter<any> = new EventEmitter();
  tituloModal: string = "Error";
  mensajeModal: string = "Listo";
  tipoModal: string = "INFO";
  isInfo: boolean = true;
  isError: boolean = false;
  classMessage:string ="";
  imagenModal: string ="" ;
  constructor(
    public translate: TranslateService,
    private router: Router,
    private genericModalService: GenericModalService,
  ) { }

  ngOnInit(): void {
    if(this.tipoModal == "SUCCESS"){
      this.imagenModal ="assets/images/icons/checkmark_success.svg";
      this.classMessage = "modal-title title";
    }
    else if(this.tipoModal == "ERROR"){
      this.imagenModal ="assets/images/icons/error-process.png";
      this.classMessage = "modal-title";
    }
  }

  closeDialog() {
    this.genericModalService.close()
    pubsub.publish("modalClosed", {})
  }
}
